import { render, staticRenderFns } from "./KD2Config.vue?vue&type=template&id=1afda402&scoped=true"
import script from "./KD2Config.vue?vue&type=script&lang=js"
export * from "./KD2Config.vue?vue&type=script&lang=js"
import style0 from "./KD2Config.vue?vue&type=style&index=0&id=1afda402&prod&lang=css"
import style1 from "./KD2Config.vue?vue&type=style&index=1&id=1afda402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afda402",
  null
  
)

export default component.exports